import React from "react";
import { NavLink } from "react-router-dom";
import { Share2, Users, User } from "lucide-react";

/**
 * Sub-navigation shown on every /admin/user/:username/* dashboard so the
 * admin can hop between Share Activity, Referral Downline, and the
 * user's public profile without going back to Search. Preserves the
 * `?range` / `?from` params so state carries across tabs.
 */
const TABS = [
  { key: "shares",  label: "Shares",   icon: Share2, color: "#00FFFF", to: (u) => `/admin/user/${u}/shares` },
  { key: "signups", label: "Signups",  icon: Users,  color: "#FFC300", to: (u) => `/admin/user/${u}/signups` },
  { key: "profile", label: "Profile",  icon: User,   color: "#39FF14", to: (u) => `/u/${u}` },
];

export default function AdminUserTabs({ username, active }) {
  if (!username) return null;
  return (
    <div
      data-testid="admin-user-tabs"
      className="flex flex-wrap gap-1 border border-white/10 p-1 w-fit"
    >
      {TABS.map((t) => {
        const isActive = active === t.key;
        const Icon = t.icon;
        // Use NavLink for the profile tab too so it navigates cleanly.
        return (
          <NavLink
            key={t.key}
            to={t.to(username)}
            data-testid={`admin-tab-${t.key}`}
            className={`flex items-center gap-1.5 px-3 py-1.5 font-mono text-[10px] uppercase tracking-widest transition-colors ${
              isActive
                ? "text-black font-bold"
                : "text-white/50 hover:text-white"
            }`}
            style={isActive ? { background: t.color } : undefined}
          >
            <Icon className="h-3 w-3" /> {t.label}
          </NavLink>
        );
      })}
    </div>
  );
}
